import styled from "@emotion/styled";

const StyledFooterTopSalesLanding = styled.div`
  background-color: ${({ theme }) => theme.colors.tone.marble};
  height: 72px;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints[2]}) {
    height: 56px;
  }
`;

const StyledSalesLandingTextBlockWrapper = styled.div`
  max-width: 590px;
  width: 100%;
  margin: 0 auto;
  position: relative;
  top: -40px;
  height: 80px;
  line-height: 80px;
`;

export { StyledFooterTopSalesLanding, StyledSalesLandingTextBlockWrapper };
